/* "Load more" for collection grids (DOF, 2026-10-06). Appends the next page of products in place,
   keeps the shopper's spot when they open a product and come back, and leaves page numbers as the
   no-JavaScript fallback. Works after filter/sort re-renders because the click handler is delegated. */
(function () {
  var KEY = 'dof-load-more:' + location.pathname;

  function grid() { return document.getElementById('product-grid'); }

  function load(box, done) {
    var btn = box.querySelector('button');
    var url = new URL(box.getAttribute('data-next-url'), location.origin);
    url.searchParams.set('section_id', box.getAttribute('data-section'));
    btn.setAttribute('aria-busy', 'true');
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('#product-grid > li');
        var g = grid();
        items.forEach(function (li) { g.appendChild(document.importNode(li, true)); });
        if (typeof window.initializeScrollAnimationTrigger === 'function') window.initializeScrollAnimationTrigger(g);
        var nextBox = doc.querySelector('.dof-load-more');
        if (nextBox) {
          box.setAttribute('data-next-url', nextBox.getAttribute('data-next-url'));
          var left = box.querySelector('.dof-load-more__left'), newLeft = nextBox.querySelector('.dof-load-more__left');
          if (left && newLeft) left.textContent = newLeft.textContent;
          btn.removeAttribute('aria-busy');
        } else {
          box.remove();
        }
        var pages = Number(sessionStorage.getItem(KEY + ':pages') || 1) + 1;
        try { sessionStorage.setItem(KEY + ':pages', String(pages)); sessionStorage.setItem(KEY + ':search', location.search); } catch (e) {}
        if (done) done();
      })
      .catch(function () { btn.removeAttribute('aria-busy'); location.href = box.getAttribute('data-next-url'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.dof-load-more__btn');
    if (!btn) return;
    e.preventDefault();
    load(btn.closest('.dof-load-more'));
  });

  // Remember the scroll spot; when a shopper comes back (and the browser did not keep the page in memory),
  // load the same number of pages again and return them to where they were.
  window.addEventListener('pagehide', function () {
    try { sessionStorage.setItem(KEY + ':y', String(window.scrollY)); } catch (e) {}
  });
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) return;
    var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    var pages = 1, y = 0;
    try {
      pages = Number(sessionStorage.getItem(KEY + ':pages') || 1);
      y = Number(sessionStorage.getItem(KEY + ':y') || 0);
      if (nav.type !== 'back_forward' || sessionStorage.getItem(KEY + ':search') !== location.search) {
        sessionStorage.removeItem(KEY + ':pages');
        return;
      }
      sessionStorage.setItem(KEY + ':pages', '1');
    } catch (e) { return; }
    (function again(n) {
      var box = document.querySelector('.dof-load-more');
      if (n <= 1 || !box) { window.scrollTo(0, y); return; }
      load(box, function () { again(n - 1); });
    })(pages);
  });
})();
